/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_Group = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_Group.prototype = {
    /* The view object name */
    name: 'group',
    /* The view object instance */
    view: {
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetBMMatchStageGroupList',
            query: {
                unionMatchId: 'matchId',
                matchId: 'matchGroupId',
                stageId: 'stageId',
                id: 'id',
                groupTeamTotal: 'groupTeamTotal'
            },
            basePath: 'data',
            rule: {
                matchId: '$id',
                matchGroupId: '$id',
                stageId: '$id',
                groupId: '$id',
                groupTeamTotal: '$id',
                teamList: '$list',
                unassignedTeamList: '$teams'
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminUpdateBMMatchStageGroupTeams',
            basePath: '',
            rule: {
                matchId: 'matchGroupId',
                stageId: 'stageId',
                groupId: 'groupId',
                teamIds: '$teamList',
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    formatTeamIds: function(teamList) {
        return teamList.join(',')
    },
    renderStageId: function(id, options) {
        return options.parameters.stageId
    },
    renderGroupId: function(id, options) {
        return options.parameters.id
    },
    renderMatchId: function(id, options) {
        return options.parameters.unionMatchId
    },
    renderMatchGroupId: function(id, options) {
        return options.parameters.matchId
    },
    renderGroupTeamTotal: function(id, options) {
        return options.parameters.groupTeamTotal
    },
    renderTeamList: function(list, options) {
        console.log('@renderTeamList', list, options)
        return list.filter(item => (item.id === options.parameters.id))[0].teams.map(item => {
            return {
                id: item.id,
                label: item.name,
                logoUrl: item.badge,
            }
        })
    },
    renderUnassignedTeamList: function(teams, options) {
        console.log('@renderUnassignedTeamList', teams, options)
        return teams.filter(item => (item.groupId == null)).map(item => {
            return {
                id: item.id,
                label: item.name,
                logoUrl: item.badge,
            }
        })
    },
}

module.exports = tbs_model_vo_Group